import { queryOptions } from '@tanstack/react-query';
import type { RouteFilters, GrantFilters, FeatureFilters } from '../model/list-params';
import { rbacApi } from './rbac-api';
import { rbacFeatureApi } from './rbac-feature-api';
export const rbacKeys = {
  all: ['rbac'] as const,
  policy: () => [...rbacKeys.all, 'policy'] as const,
  subjects: () => [...rbacKeys.all, 'subjects'] as const,
  routes: (filters: RouteFilters) => [...rbacKeys.policy(), 'routes', filters] as const,
  route: (id: string) => [...rbacKeys.policy(), 'route', id] as const,
  matrix: ({ q, vertical }: RouteFilters) =>
    [...rbacKeys.policy(), 'matrix', { q, vertical }] as const,
  grants: (filters: GrantFilters) => [...rbacKeys.policy(), 'grants', filters] as const,
  fieldRules: (id: string) => [...rbacKeys.policy(), 'field-rules', id] as const,
  features: (filters: FeatureFilters) =>
    [...rbacKeys.policy(), 'features', filters] as const,
  feature: (id: number) => [...rbacKeys.policy(), 'feature', id] as const,
  audit: (beforeId?: number) => [...rbacKeys.policy(), 'audit', beforeId] as const,
};
export const rbacQueries = {
  subjects: () =>
    queryOptions({ queryKey: rbacKeys.subjects(), queryFn: () => rbacApi.subjects() }),
  routes: (filters: RouteFilters) =>
    queryOptions({
      queryKey: rbacKeys.routes(filters),
      queryFn: () => rbacApi.routes(filters),
    }),
  route: (id: string) =>
    queryOptions({ queryKey: rbacKeys.route(id), queryFn: () => rbacApi.route(id) }),
  matrix: (filters: RouteFilters) =>
    queryOptions({
      queryKey: rbacKeys.matrix(filters),
      queryFn: () => rbacApi.matrix(filters),
    }),
  grants: (filters: GrantFilters) =>
    queryOptions({
      queryKey: rbacKeys.grants(filters),
      queryFn: () => rbacApi.grants(filters),
    }),
  fieldRules: (id: string) =>
    queryOptions({
      queryKey: rbacKeys.fieldRules(id),
      queryFn: () => rbacApi.fieldRules(id),
    }),
  features: (filters: FeatureFilters) =>
    queryOptions({
      queryKey: rbacKeys.features(filters),
      queryFn: () => rbacFeatureApi.list(filters),
    }),
  feature: (id: number) =>
    queryOptions({
      queryKey: rbacKeys.feature(id),
      queryFn: () => rbacFeatureApi.get(id),
    }),
  audit: (beforeId?: number) =>
    queryOptions({
      queryKey: rbacKeys.audit(beforeId),
      queryFn: () => rbacApi.audit(),
    }),
};
